var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessseeker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m225 255h-30v-30h-75v60h180v-60h-75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 112.485c-5.244-3.12-15.205-7.485-30-7.485-14.751 0-24.697 4.336-30 7.515v22.485h60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 165h180v30h-180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 420c115.796 0 210-94.204 210-210s-94.204-210-210-210-210 94.204-210 210 94.204 210 210 210zm-120-285h60v-36.211l4.395-4.395c1.977-1.992 20.405-19.394 55.605-19.394s53.628 17.402 55.605 19.395l4.395 4.394v36.211h60v180h-240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.795 408.428 103.572 103.572 63.633-63.633-103.572-103.572c-17.031 24.988-38.645 46.602-63.633 63.633z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessseeker);
export default __webpack_public_path__ + "static/media/Business seeker.606ea4681aa7fa3b572330c7bcca73ad.svg";
export { ForwardRef as ReactComponent };